import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import InlineTextInput from 'Workspace/Cohorts/components/CohortPageHeader/InlineTextInput';
import projectServiceShape from 'services/types/projectService';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import enhanceWithServices from 'hocs/enhanceWithServices';
import { PermissionTypes } from 'constants/enums';

import { ProjectTitleWrapper } from './styles';

function ProjectTitle({
  projectId,
  title,
  projectService,
  currentUser,
  permissionLevel,
  onTitleChange,
}) {
  const [isProjectNameEditable, setIsProjectNameEditable] = useState(false);

  useEffect(() => {
    const handleEditProjectNamePermission = async () => {
      if (!currentUser || !permissionLevel) {
        return;
      }

      switch (permissionLevel) {
        case PermissionTypes.OWNER:
        case PermissionTypes.CONTRIBUTOR:
          setIsProjectNameEditable(true);
          break;
        default:
          setIsProjectNameEditable(false);
      }
    };

    handleEditProjectNamePermission();
  }, [currentUser, permissionLevel]);

  const handleProjectNameChange = async (newName) => {
    onTitleChange(newName);
    await projectService.replaceProject(projectId, newName);
  };

  return (
    <ProjectTitleWrapper>
      { isProjectNameEditable
        ? <InlineTextInput value={title} onChange={handleProjectNameChange} />
        : title
      }
    </ProjectTitleWrapper>
  );
}

ProjectTitle.propTypes = {
  projectId: PropTypes.string,
  title: PropTypes.string,
  permissionLevel: PropTypes.string,
  projectService: projectServiceShape,
  currentUser: PropTypes.object,
  onTitleChange: PropTypes.func,
};

const mapStateToProps = (state) => ({
  currentUser: selectCurrentMe(state),
});

const withConnect = connect(mapStateToProps, null);
export default compose(withConnect, enhanceWithServices)(ProjectTitle);
